function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 20.508,
  height: 20.508,
  rx: 2,
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M0,5.882A1.367,1.367,0,0,1,.609,4.745L6.078,1.1A1.367,1.367,0,0,1,8.2,2.236v15.4a1.367,1.367,0,0,1-2.126,1.138L.609,15.127A1.367,1.367,0,0,1,0,13.989Z",
  transform: "translate(23.242 0.318)",
  fill: "#fff"
});

var SvgVideoCamera = function SvgVideoCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12",
    "data-name": "Group 12",
    width: 31.445,
    height: 20.508,
    viewBox: "0 0 31.445 20.508",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-camera.4d55c5de.svg";
export { ForwardRef as ReactComponent };